import { createContext } from "react";

export interface SnackbarContextType {
    snackbars: { content: string; severity: string }[];
    showSnackbar: (content: string, severity: "success" | "error") => void;
}

const initialValue: SnackbarContextType = {
    snackbars: [],
    showSnackbar: (_content: string, _severity: "success" | "error") => {},
};

export const SnackbarContext = createContext(initialValue);
